import { useState, useEffect } from "react";
import { u as ue } from "./storyblok-js-5fd880b4.mjs";
import { y, i, c, g, d, h } from "./storyblok-js-5fd880b4.mjs";
import { u as useStoryblokApi } from "./index-4af66cd0.mjs";
import { S, g as g2, s, a } from "./index-4af66cd0.mjs";
import { u } from "./client-798eb80c.mjs";
const useStoryblok = (slug, apiOptions = {}, bridgeOptions = {}) => {
  const storyblokApiInstance = useStoryblokApi();
  if (!storyblokApiInstance) {
    console.error(
      "You can't use useStoryblok if you're not loading apiPlugin."
    );
    return null;
  }
  let [story, setStory] = useState({});
  const isBridgeEnable = typeof window !== "undefined" && typeof window.storyblokRegisterEvent !== "undefined";
  useEffect(() => {
    async function initStory() {
      const { data } = await storyblokApiInstance.get(
        `cdn/stories/${slug}`,
        apiOptions
      );
      setStory(data.story);
      if (isBridgeEnable && data.story.id) {
        ue(
          data.story.id,
          (story2) => setStory(story2),
          bridgeOptions
        );
      }
    }
    initStory();
  }, [slug, JSON.stringify(apiOptions)]);
  return story;
};
export {
  y as RichTextResolver,
  i as RichTextSchema,
  S as StoryblokComponent,
  c as apiPlugin,
  g2 as getComponent,
  useStoryblokApi as getStoryblokApi,
  g as loadStoryblokBridge,
  ue as registerStoryblokBridge,
  d as renderRichText,
  s as setComponents,
  h as storyblokEditable,
  a as storyblokInit,
  useStoryblok,
  useStoryblokApi,
  ue as useStoryblokBridge,
  u as useStoryblokState
};
